import { render } from "./TheGame.vue?vue&type=template&id=43f79bca&scoped=true"
import script from "./TheGame.vue?vue&type=script&lang=js"
export * from "./TheGame.vue?vue&type=script&lang=js"

import "./TheGame.vue?vue&type=style&index=0&id=43f79bca&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-43f79bca"]])

export default __exports__